import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-snippet-dialog',
  templateUrl: './image-snippet-dialog.component.html',
  styleUrls: ['./image-snippet-dialog.component.scss']
})
export class ImageSnippetDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageSnippetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { captured: string; search: string; verified: string }
  ) {}
}